<div
    class="column description"
    #descriptionCell
    [class.expanded]="isDescriptionExpanded"
    [class.emptyCell]="!description"
    [style.display]="canFitDescription || !description ? 'flex' : 'block'">
    <ng-container *ngIf="description; else dash">
        <span class="description-text">{{ isDescriptionExpanded ? fullDescription : displayedDescription }}</span>
        <button
            *ngIf="isDescriptionTruncated || isDescriptionExpanded"
            type="button"
            class="show-more-btn"
            [class.isExpanded]="isDescriptionExpanded"
            (click)="toggleDescription()">
            {{ isDescriptionExpanded ? ('dlg.show-less' | translate) : ('dlg.show-more' | translate) }}
        </button>
    </ng-container>
    <ng-template #dash>{{ emptyText | translate }}</ng-template>

    <span #measureEl class="description-measure" aria-hidden="true"></span>
</div>
